import React from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function Pagination({ page, pageSize, total }) {
  const [params, setParams] = useSearchParams();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;
  const go = (p) => {
    const np = new URLSearchParams(params);
    np.set("page", String(p));
    setParams(np);
  };
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-muted-foreground">
        Page {page} of {totalPages} · {total} total
      </span>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => go(page - 1)}>
          Previous
        </Button>
        <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => go(page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
